import { localStorageClear, localStorageGet, localStorageSave } from '@alexis/helpers/localStorage';

import { USER_V3_LOCAL_STORAGE_KEY } from '@constants/localStorage';

import { UserV3ActionTypes } from '@redux/actions/types';

import { UserV3 } from '@wegoTypes/userV3';

const userV3 = localStorageGet<UserV3>(USER_V3_LOCAL_STORAGE_KEY);

const initialState: UserV3 | null = userV3;

export default function (
  state: UserV3 | null = initialState,
  action: { type: UserV3ActionTypes; payload: UserV3 },
) {
  switch (action.type) {
    case UserV3ActionTypes.ChangeUserV3: {
      const userV3 = action.payload;
      localStorageSave(USER_V3_LOCAL_STORAGE_KEY, userV3);
      return userV3;
    }
    case UserV3ActionTypes.ResetUserV3: {
      localStorageClear(USER_V3_LOCAL_STORAGE_KEY);
      return null;
    }
    default: {
      return state;
    }
  }
}
